import React from "react";
import { toast } from "sonner";
import { Bot, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu";

// Número e texto de abertura do suporte — os mesmos do link direto que o
// cabeçalho usava até a v1.5.757.
const WHATSAPP_SUPORTE =
  "https://wa.me/553431970131?text=Quero%20tirar%20uma%20d%C3%BAvida%20sobre%20o%20assunto%3A";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
  </svg>
);

// Mesma cor do selo "Em breve" do menu lateral (BADGE_VARIANTS.soon).
const SeloEmBreve = () => (
  <span className="ml-auto inline-flex items-center px-1.5 py-0.5 rounded-full text-[9px] font-black tracking-wider uppercase text-white bg-gradient-to-r from-amber-500 to-orange-600 shadow-sm">
    Em breve
  </span>
);

/**
 * Botão "Suporte" do cabeçalho: abre as duas formas de pedir ajuda.
 * - WhatsApp: abre a conversa com o time (o que o botão fazia sozinho antes).
 * - CLEO: assistente dentro do painel — anunciada, ainda não disponível.
 * Plano da CLEO: docs/features/cleo-suporte/.
 */
export default function SuporteMenu() {
  const avisarCleo = () =>
    toast.info("A CLEO de suporte está chegando! Por enquanto, fale com o time pelo WhatsApp.");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-bold text-white transition-all hover:brightness-95"
          style={{ backgroundColor: "#25D366" }}
          title="Suporte"
          aria-label="Suporte"
        >
          <WhatsAppIcon className="w-4 h-4" />
          <span className="hidden sm:inline">Suporte</span>
          <ChevronDown className="w-3 h-3 opacity-80" aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72">
        <DropdownMenuLabel>Como podemos ajudar?</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild className="cursor-pointer py-2.5">
          <a href={WHATSAPP_SUPORTE} target="_blank" rel="noopener noreferrer">
            <span className="mr-3 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-white" style={{ backgroundColor: "#25D366" }}>
              <WhatsAppIcon className="w-4 h-4" />
            </span>
            <span className="flex flex-col">
              <span className="font-semibold">Suporte no WhatsApp</span>
              <span className="text-xs text-muted-foreground">Fale com o nosso time</span>
            </span>
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={avisarCleo} className="cursor-pointer py-2.5">
          <span className="mr-3 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-violet-100 text-violet-600 dark:bg-violet-900/40 dark:text-violet-300">
            <Bot className="w-4 h-4" />
          </span>
          <span className="flex flex-col">
            <span className="font-semibold">Suporte com a CLEO</span>
            <span className="text-xs text-muted-foreground">Tira dúvidas do sistema na hora</span>
          </span>
          <SeloEmBreve />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
